import React, { FC } from 'react';

import { CircleQuestion } from '@gravity-ui/icons';
import { Icon } from '@gravity-ui/uikit';
import clx from 'classnames';
import { hrefIsExternal } from 'client/utils';

import { HashLink } from './HashLink';
import styles from './Link.module.scss';

interface Props {
    icon?: string;
    external?: boolean;
    to?: string;
    isCurrentPath?: boolean;
    theme?: 'info' | 'menu';
    classNames?: string;
    children?: React.ReactNode;
}

export const Link: FC<Props & React.HTMLProps<HTMLAnchorElement>> = ({
    icon,
    isCurrentPath,
    external,
    to,
    children,
    theme = 'menu',
    classNames = '',
    ...restProps
}) => {
    const style = { backgroundImage: '' };
    if (icon) {
        style.backgroundImage = 'url(' + icon + ')';
    }

    const classNamesCalculated = clx(
        styles.menuLink,
        isCurrentPath && styles.menuLink_active,
        theme === 'info' && styles.theme_info,
        classNames,
    );

    if (typeof to === 'string' && (external || hrefIsExternal.test(to))) {
        return (
            <a href={to} className={classNamesCalculated} rel="noopener noreferrer" {...restProps}>
                {icon && <div style={style} />}
                {children}
            </a>
        );
    }

    return (
        <HashLink className={classNamesCalculated} smooth to={to || '/'}>
            {icon && <div style={style} />}
            {children}
        </HashLink>
    );
};

export const QuestionLink: FC<Props> = ({ to }) => {
    return (
        <Link className={styles.questionLink} to={to} target="_blank" external>
            <Icon data={CircleQuestion} />
        </Link>
    );
};
